import { render, staticRenderFns } from "./newFbpClaim.vue?vue&type=template&id=b01e8b72&scoped=true&lang=html"
import script from "./newFbpClaim.vue?vue&type=script&lang=js"
export * from "./newFbpClaim.vue?vue&type=script&lang=js"
import style0 from "./newFbpClaim.vue?vue&type=style&index=0&id=b01e8b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01e8b72",
  null
  
)

export default component.exports